import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {COMPONENT_DECLARATIONSWEB, MODULESWEB, PROVIDERSWEB} from '~/app/web-ngComponents';
import {ApptemplateLibModule, ENVIRONMENTERTEMPLATE, LoggingService} from 'mclane-apptemplate-lib';
import {KeycloakService} from 'keycloak-angular';
// @ts-ignore
import {
    AppAuthGuard, AuthenticationModule,
    AuthInit, AuthInterceptorService,
    ChallengeGuard,
    ChallengeModule,
    CookieManagementService,
    JwtService,
    OauthService,
    WEBAUTHENVIRONMENTER
} from 'mclane-webauth-lib';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '~/environments/environment';
import {ActivityComponent} from './web/webcomponents/activity/activity.component';
import {ApplicationdivComponent} from './web/webcomponents/applicationdiv/applicationdiv.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {KeycloakHelperService} from '~/app/core/helpers/keycloak-helper.service';
import {DashboardComponent} from './web/dashboard/dashboard.component';
import {AuthInitService} from '~/app/core/services/auth-init.service';
import {CookieService} from 'ngx-cookie-service';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaModule, ReCaptchaV3Service} from 'ng-recaptcha';
import {Overlay, OverlayContainer, ToastrService} from 'ngx-toastr';
import {HTTP_INTERCEPTORS} from '@angular/common/http';


export function AuthFactory(keycloakService: KeycloakService, authInit: AuthInit,
                            jwtservice: JwtService, keyCloakHelperService: KeycloakHelperService,
                            cookieHelperService: CookieManagementService, oauthService: OauthService, console: LoggingService) {
    return (): Promise<any> => {
        const authService = new AuthInitService(console);
        return authService
            .authSetup(keycloakService, authInit, jwtservice, keyCloakHelperService, cookieHelperService, oauthService).then(() => {
            });
    };
}

@NgModule({
    declarations: [
        ...COMPONENT_DECLARATIONSWEB,
        ActivityComponent,
        ApplicationdivComponent,
        DashboardComponent,

    ],
    imports: [
        ...MODULESWEB,
        ApptemplateLibModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        BrowserAnimationsModule,
        AuthenticationModule,
        ChallengeModule,
        RecaptchaModule
    ],
    providers: [
        ...PROVIDERSWEB,
        CookieService,
        ReCaptchaV3Service,
        ChallengeGuard,
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
        {
            provide: APP_INITIALIZER,
            useFactory: AuthFactory,
            multi: true,
            deps: [KeycloakService, AuthInit, JwtService, KeycloakHelperService, CookieManagementService, OauthService, LoggingService]
        },
        AppAuthGuard,
        ToastrService,
        Overlay,
        OverlayContainer,
        {provide: WEBAUTHENVIRONMENTER, useValue: environment},
        {provide: ENVIRONMENTERTEMPLATE, useValue: environment},
        {provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Lchb6MZAAAAAKm5BjabNHPTJDq9CorYDIBYkgyW'}]
    ,
    bootstrap: [AppComponent]
})
export class AppModule {
}
